import { Component, OnInit } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { TranslateService } from '@ngx-translate/core';

import { CustomPopupComponent } from '../custom-popup/custom-popup.component';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.sass']
})
export class ResetPasswordDialogComponent implements OnInit {

  resetPasswordEmailForm: FormGroup;
  showBar: boolean = false;

  constructor(
    private selfRef: MatDialogRef<ResetPasswordDialogComponent>,
    public auth: AngularFireAuth,
    public fb: FormBuilder,
    private snackbar: MatSnackBar,
    private dataService: DataService,
    private translate: TranslateService,
  ) {
    this.resetPasswordEmailForm = fb.group({
      email: new FormControl('', [Validators.required, Validators.email])
    })
  }

  ngOnInit(): void {
  }


  sendResetPasswordEmail(form: FormGroup) {
    this.showBar = true;

    if (!form.valid) {

      this.translate.get('alerts.invalid_email_error').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })

      this.showBar = false;
      throw new Error('Invalid email address')
    }


    let emailAddress = form.value.email;
    let lang = this.translate.currentLang





    this.dataService.resetPasswordFromLogin({ email: emailAddress, language: lang }).subscribe(res => {

      if (res.status == 'error') {

        // switch (localStorage.getItem('language')) {
        switch (this.translate.currentLang) {
          case 'es':
            this.snackbar.open('La dirección de correo electrónico ingresada no es válida o no hay ningún usuario que corresponda a esa dirección de correo electrónico.', 'Cerrar')
            break;
          case 'en':
            this.snackbar.open('The entered email address is not valid or there is no user corresponding to the email address.', 'Close')
            break;
          case 'cat':
            this.snackbar.open("L'adreça electrònica introduïda no és vàlida o no hi ha cap usuari corresponent a l'adreça electrònica.", 'Cerca')
            break;
          default:
            this.snackbar.open('The entered email address is not valid or there is no user corresponding to the email address.', 'Close')

        }

        this.showBar = false;
        this.selfRef.close();
        throw new Error(res.message)

      } else {

        this.showBar = false;

        // switch (localStorage.getItem('language')) {
        switch (this.translate.currentLang) {
          case 'es':
            this.snackbar.open('El correo electrónico se ha enviado con éxito. Por favor revise su bandeja de entrada.', 'Cerrar')
            break;
          case 'en':
            this.snackbar.open('Email has been sent succesfully. Please check your inbox.', 'Close')
            break;
          case 'cat':
            this.snackbar.open('El correu electrònic s’ha enviat amb èxit. Comproveu la safata d’entrada.', 'Cerca')
            break;
          default:
            this.snackbar.open('Email has been sent succesfully. Please check your inbox.', 'Close')

        }

        this.selfRef.close();

      }

    })


  }

}
